<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        background-color="#304156"
        text-color="#bfcbd9"
        :unique-opened="true"
        :active-text-color="settings.theme"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in permission_routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";

export default {
  data() {
    return {};
  },
  components: { SidebarItem, Logo },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters(["permission_routes", "sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (document.title.indexOf(".") != -1) {
        document.title = meta.title;
      }
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  beforeCreate() {
    // 动态切换多语言
    let rts = this.$store.getters.permission_routes;
    for (let idx in rts) {
      let ros = rts[idx];
      if (!ros.children) {
        continue;
      }
      for (let cidx in ros.children) {
        let subRos = ros.children[cidx];
        if (!subRos.meta || !subRos.meta.title) {
          continue;
        }
        let dtitle = subRos.meta.title;
        if (dtitle.indexOf(".") != -1) {
          subRos.meta.title = this.$t(subRos.meta.title);
        }
      }
    }
  },
  mounted() {
    const route = this.$route;
    const { meta } = route;
    if (meta && meta.title) {
      document.title = meta.title;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue